module.exports = "/_next/static/images/buyers_3-ae56dc1066b0e5677168deab5f8d1539.png";